import { Fragment, type ReactNode } from 'react';
import { tokenizeNoteMarkup } from '@cca/corpus-shared';

/**
 * Render a commentary note body with its lightweight markup
 * (`**bold**` / `*italic*` / `_underline_`) as React nodes. Text content comes
 * through React text nodes, so it is auto-escaped — no dangerouslySetInnerHTML.
 */
export function renderNoteBody(body: string): ReactNode {
  return tokenizeNoteMarkup(body).map((t, i) => {
    if (t.bold) return <strong key={i}>{t.text}</strong>;
    if (t.italic) return <em key={i}>{t.text}</em>;
    if (t.underline) return <u key={i}>{t.text}</u>;
    return <Fragment key={i}>{t.text}</Fragment>;
  });
}
